import React from "react";
import { Grid, Divider, Button, TextField } from "@mui/material";
import { ValidatorForm } from "react-material-ui-form-validator";
import useMessageNotifier from "../../../../helpers/hooks/component/useMessageNotifier";
import { useKeycloak } from "@react-keycloak/web";
import ReactPasswordChecklist from "react-password-checklist";
import DOMHelper from "../../../../helpers/DOMHelper";
import { toggleLoading } from "../../../../store/slices/loadingSlice";
import UserService from "../../../../api/extranet/services/UserService";
import { useDispatch } from "react-redux";
import SubCard from "../../../berry/ui-component/cards/SubCard";

const PasswordEditForm = ({ account }) => {
    const dispatch = useDispatch();
    const { showMessage } = useMessageNotifier();
    const { keycloak } = useKeycloak();
    const mainForm = React.useRef();
    const [state, setState] = React.useState({
        password: '',
        confirmPassword: ''
    });
    const [isPasswordValid, setIsPasswordValid] = React.useState(false);
    const [isSubmittedSuccessfully, setIsSubmittedSuccessfully] = React.useState(false); // New state variable

    const handleChange = (event) => {
        setState(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value
        }));
        setIsPasswordValid(false); // Reset validity when password changes
        setIsSubmittedSuccessfully(false); // Reset success status
    };

    const callUpdatePassword = async () => {
        dispatch(toggleLoading());
        const resultCall = await UserService.updateUserPassword(keycloak.token, account.user.extranetUuid, { password: state.password });
        dispatch(toggleLoading());
        return resultCall;
    };

    const handleSubmit = () => {
        mainForm.current.isFormValid(false)
            .then(async (valid) => {
                if (valid) {
                    const resultCall = await callUpdatePassword();
                    if (resultCall.code === 200) {
                        setState({ password: '', confirmPassword: '' });
                        setIsSubmittedSuccessfully(true); // Set success status
                        showMessage(resultCall.message, 'success');
                    } else {
                        showMessage(resultCall.message, 'error');
                    }
                } else {
                    DOMHelper.scrollToError();
                }
            });
    };

    const buttonDisabled = () => !isPasswordValid || isSubmittedSuccessfully; // Disable button if password is invalid or submission was successful

    return (
        <Grid item lg={6} xs={12}>
            <SubCard title="Mon mot de passe">
                <Grid container spacing={2}>
                    <Divider sx={{ pt: 1 }} />
                    <Grid item xs={12}>
                        <ValidatorForm
                            ref={mainForm}
                            onSubmit={handleSubmit}
                            onError={() => console.error('onError')}
                        >
                            <TextField
                                fullWidth
                                name="password"
                                label="J’indique un nouveau mot de passe"
                                type="password"
                                value={state.password}
                                onChange={handleChange}
                                margin="normal"
                                variant="outlined"
                            />
                            <TextField
                                fullWidth
                                name="confirmPassword"
                                label="Je confirme mon nouveau mot de passe"
                                type="password"
                                value={state.confirmPassword}
                                onChange={handleChange}
                                margin="normal"
                                variant="outlined"
                            />
                            <br />
                            {state.password && (
                                <Grid item xs={12} sm={12} className="p-px-5">
                                    <ReactPasswordChecklist
                                        rules={["lowercase", "minLength", "specialChar", "number", "capital", "match"]}
                                        minLength={12}
                                        value={state.password}
                                        valueAgain={state.confirmPassword}
                                        onChange={(isValid) => setIsPasswordValid(isValid)} // Update validity state
                                        messages={{
                                            minLength: "Le mot de passe doit contenir au moins 12 caractères.",
                                            capital: "Le mot de passe doit contenir au moins une lettre majuscule.",
                                            lowercase: "Le mot de passe doit contenir au moins une lettre minuscule.",
                                            number: "Le mot de passe doit contenir au moins un chiffre.",
                                            specialChar: "Le mot de passe doit contenir au moins un caractère spécial.",
                                            match: "La confirmation du mot de passe ne correspond pas au mot de passe saisi.",
                                        }}
                                    />
                                </Grid>
                            )}
                            <Button
                                variant="contained"
                                type="submit"
                                color="secondary"
                                disabled={buttonDisabled()} // Use the validity state to enable/disable the button
                                sx={{ mt: 2, textTransform: 'none' }}
                            >
                                Je valide
                            </Button>
                        </ValidatorForm>
                    </Grid>
                </Grid>
            </SubCard>
        </Grid>
    );
};

export default PasswordEditForm;
